import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import CountryList from "./country-list";
import AddCountry from "./add-country";
import EditCountry from "./edit-country";
import ViewCountry from "./view-country";

const PARENT_URL = "/cms/countries";

const Countries = () => {
  return (
    <Routes>
      <Route path={`/list`} element={<CountryList />} />
      <Route path={`/add/:countryCode`} element={<AddCountry />} />
      <Route path={`/view/:countryCode`} element={<ViewCountry />} />
      <Route path={`/edit/:countryCode`} element={<EditCountry />} />
      <Route path={``} element={<Navigate to={`${PARENT_URL}/list`} replace />} />
    </Routes>
  );
};

export default Countries;
